import {Space} from 'antd';
import styled from 'styled-components';
import {typographyStyles} from '../../utils/styles';

const StyledMissingInfo = styled(Space)`
  align-items: center;

  .anticon {
    color: ${props => props.theme.colors.functional_warning};
  }
`;

const StyledMissingInfoDescription = styled.div`
  ${typographyStyles.body.regular};
  color: ${props => props.theme.colors.functional_warning};
  text-wrap: nowrap;
`;

export {
  StyledMissingInfo,
  StyledMissingInfoDescription
};
